import { PageQuery, Paginate } from '@business/entities/common';
import { OrderBrandId, OrderProductId, OrderProductResponse } from '@business/entities/order';
import { CommonService } from '@business/services';
import { R } from '@core/utils/r';
import { ProductFormData } from '@modules/orders/ProductsPage/AddEditProductOverlay/AddEditProductOverlay';
import { Endpoint } from '../endpoint';
import { PageStatResponse } from '@business/entities/stats';

export function fetchProductsPaginated(
  params: PageQuery,
  products?: OrderProductId[],
  vendorId?: string,
  categoryId?: string,
  brandId?: OrderBrandId,
  status?: string,
  fromAddProduct = false,
) {
  return Endpoint.get<Paginate<OrderProductResponse>>(`@gc/products`, {
    params: R.objectCompact({ ...params, ...R.objectCompact({ products, vendorId, categoryId, brandId, status }), fromAddProduct }),
  });
}

export function fetchProducts(isPaginated?: string) {
  const params = R.objectCompact({ isPaginated });
  return Endpoint.get<OrderProductResponse[]>(`@gc/products`, { params });
}

export function fetchAllProducts() {
  return Endpoint.get<OrderProductResponse[]>(`@gc/products/all`);
}

export function fetchProduct(id: OrderProductId) {
  return Endpoint.get<OrderProductResponse>(`@gc/products/product/${id}`);
}

export function createProduct(data: Partial<ProductFormData>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<OrderProductResponse>(`@gc/products`, { formData, hasFiles: true });
}

export function updateProduct(id: OrderProductId, data: Partial<ProductFormData>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<OrderProductResponse>(`@gc/products/product/${id}`, { formData, hasFiles: true });
}

export function deleteProduct(id: OrderProductId) {
  return Endpoint.delete<void>(`@gc/products/${id}`);
}

export function toggleStatus(id: OrderProductId) {
  return Endpoint.post<OrderProductResponse>(`@gc/products/status/${id}`);
}

export function syncProducts() {
  return Endpoint.get<OrderProductResponse[]>(`@gc/products/sync`);
}

export function pageStats() {
  return Endpoint.get<PageStatResponse[]>(`@gc/products/page-stats`);
}
